import { useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { useCompanyData, getPrivacySections } from "../data/privacyPolicy";

export default function PoliticaPrivacidade() {
    const companyData = useCompanyData();
    const privacySections = getPrivacySections(companyData);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div>
            <Header />

            <main className="bg-gray-50 min-h-screen pt-24 pb-16 mt-32">
                <section className="max-w-5xl mx-auto px-6">
                    <div className="bg-white shadow-lg rounded-2xl p-6 md:p-10 border border-gray-100">
                        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-8">
                            <div>
                                <p className="text-xs uppercase tracking-[0.2em] text-red-600 font-semibold">
                                    {companyData.name}
                                </p>
                                <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mt-1">
                                    Política de Privacidade
                                </h1>
                                <p className="text-sm text-gray-500 mt-2">
                                    Última atualização: julho de 2026 · Em conformidade com a LGPD
                                </p>
                            </div>
                            <div className="flex gap-2 text-sm text-gray-600">
                                <span className="px-3 py-2 rounded-lg bg-gray-100 border border-gray-200">
                                    CNPJ / CPF: {companyData.cnpj}
                                </span>
                            </div>
                        </div>

                        <div className="grid grid-cols-1 md:grid-cols-[240px_1fr] gap-8">
                            <nav className="hidden md:block sticky top-24 space-y-2">
                                {privacySections.map((section) => (
                                    <a
                                        key={section.id}
                                        href={`#${section.id}`}
                                        className="block px-3 py-2 rounded-lg text-sm text-gray-600 hover:text-red-600 hover:bg-red-50 border border-transparent hover:border-red-100 transition"
                                    >
                                        {section.title}
                                    </a>
                                ))}
                            </nav>

                            <div className="space-y-8">
                                {privacySections.map((section) => (
                                    <article key={section.id} id={section.id} className="bg-white border border-gray-100 rounded-xl p-5 shadow-sm">
                                        <h2 className="text-lg font-bold text-gray-900">
                                            {section.title}
                                        </h2>
                                        <div className="w-12 h-0.5 bg-red-600 mt-2 mb-4" />
                                        <p className="text-sm leading-7 whitespace-pre-line text-gray-700">
                                            {section.content}
                                        </p>
                                    </article>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
            </main>

            <Footer />
        </div>
    );
}
